import styled from "styled-components";

export const Content = styled.div.attrs({})`
  padding: 40px clamp(18px, 3vw, 40px);
  @media (max-width: 500px) { 
    padding: 16px;
  }
`;

export const DetailsContent = styled.div.attrs({})`
  display: flex;  
  gap: 24px;
  @media (max-width: 991px) {
    flex-direction: column;
  }
`;

export const DetailsContainer = styled.div.attrs({})`
  flex: 1;
  background: ${p => p.theme.palette.colors.surfaceElevatedSoft};
  border: 1px solid ${p => p.theme.palette.colors.borderSoft};
  border-radius: 24px;
  padding: 18px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: flex-end;
  box-shadow: 0 24px 56px ${p => p.theme.palette.colors.shadowStrong};
  `;

export const TicketContainer = styled.div.attrs({})`
  flex: 1;
  height: 100%;
  background: ${p => p.theme.palette.colors.surfaceElevatedSoft};
  border: 1px solid ${p => p.theme.palette.colors.borderSoft};
  border-radius: 24px;
  padding: 18px;
  max-width: 475px;
  box-shadow: 0 24px 56px ${p => p.theme.palette.colors.shadowStrong};
    @media (max-width: 991px) {
    max-width: 100%;
  }
`;


export const DetailsBody = styled.div.attrs({})`
  padding: 24px;
  border-radius: 20px;
  border: 1px solid ${p => p.theme.palette.colors.borderSoft};
  background: ${p => p.theme.palette.colors.surfaceElevated};
  width: 100%;
`;

export const DetailsTitle = styled.div.attrs({})`
  font-family: Gilroy;
  font-size: clamp(28px, 4vw, 36px);
  font-weight: 700;
  line-height: 1.06;
  letter-spacing: -0.04em;
  color: ${p => p.theme.palette.colors.text};

  @media (max-width: 500px) {
    font-size: 24px;
  }
`;

export const InfoDetails = styled.div.attrs({})`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 24px 0;
  border-bottom: 1px solid ${p => p.theme.palette.colors.borderSoft};
  padding-bottom: 24px;
  flex-wrap: wrap;
`;

export const InfoText = styled.div.attrs({})`
  font-family: Lato;
  font-size: 18px;
  font-style: normal;
  font-weight: 500; 
  color: ${p => p.theme.palette.colors.muted};
`;

export const Text = styled.div.attrs({})`
  font-family: Lato;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  color: ${p => p.theme.palette.colors.muted};
`;

export const SupportContainer = styled.div.attrs({})`
  padding: 24px;
  border-radius: 20px;
  border: 1px solid ${p => p.theme.palette.colors.borderSoft};
  max-width: 792px;
  background: ${p => p.white ? p.theme.palette.colors.surfaceElevated : p.theme.palette.colors.surface};
  width: 100%;
  box-shadow: 0 18px 42px ${p => p.theme.palette.colors.shadowStrong};
  ${
    p => !p?.mine ? `
      align-self:flex-start;
    ` : ``
  }
  ${
    p => p?.text ? `
      max-width: 100%;
    ` : ``
  }
  
`;

export const HeaderDetails = styled.div.attrs({})`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${p => p.theme.palette.colors.borderSoft};
  padding-bottom: 24px;
  margin-bottom: 24px;
`;

export const TicketTitle = styled.div.attrs({})`
  font-family: Gilroy;
  font-size: 24px;
  font-weight: 700;
  color: ${p => p.theme.palette.colors.text};
`;
